import React from 'react';
import ReactDOM from 'react-dom';
import '../../entity/entity.scss';
import { LawFirmApp } from './LawFirmApp';
import { CustomWindow } from './lawFirm.types';
import { snakeToCamel } from '../../../admin/axiosUtils';

declare let window: CustomWindow;

const target = document.querySelector(`[data-react=doctrine-react]`);
if (target) {
  ReactDOM.render(
    <LawFirmApp
      lawFirmInfos={snakeToCamel(window.lawFirmInfos)}
      readKey={window.read_key}
    />,
    target,
  );
} else {
  // eslint-disable-next-line no-console
  console.log(`doctrine-react is not visible in the DOM`);
}
